// extracted by mini-css-extract-plugin
export default {"ItemTitle":"LeaderBoardCard_ItemTitle__NHbDn","ItemTime":"LeaderBoardCard_ItemTime__Z2+po","ItemContent":"LeaderBoardCard_ItemContent__RtLjb"};